import { useEffect } from "react";
import { getFamilyHistory } from "../../../apiHandler/actions/profile";
import { DataGridCustomPagination } from "../../helpers";
import { Skeleton } from "@material-ui/lab";

import { DataGrid } from "@mui/x-data-grid";

const columns = [
  { field: "diseaseName", headerName: "Disease Name", flex: 1 },
  { field: "familyMember", headerName: "Family Member", flex: 1 },
  { field: "comments", headerName: "Comments", flex: 1 },
];

const Component = (props) => {
  const { familyHistory, setFamilyHistory } = props;

  useEffect(() => {
    if (familyHistory === null) fetchAllergies();
    // eslint-disable-next-line
  }, []);

  const fetchAllergies = async () => {
    const response = await getFamilyHistory(props.uuid);
    setFamilyHistory(
      response.familyMemberHistory &&
        response.familyMemberHistory.map((f) => {
          return {
            id: f.id,
            diseaseName: f.condition[0]?.code?.coding[0]?.display,
            familyMember: f.relationship?.coding[0]?.code,
            comments: f.condition[0]?.note[0],
          };
        })
    );
  };

  return (
    <div>
      {familyHistory === null ? (
        <div className="mj-skeleton-container">
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
          <Skeleton variant="text" height={20} style={{ marginTop: 10 }} />
        </div>
      ) : Array.isArray(familyHistory) && familyHistory.length !== 0 ? (
        <DataGrid
          rows={familyHistory}
          columns={columns}
          autoHeight="true"
          disableRowSelectionOnClick
          pagination
          pageSize={5}
          slots={{
            pagination: DataGridCustomPagination,
          }}
        />
      ) : (
        <p className="mj-no-records">No records to display</p>
      )}
    </div>
  );
};

export default Component;
